import api from "./api";
export const fetcher = async (url) => {
    const request = await api.API.get(url, {
        credentials: "include",
    });
    return request.json();
};
